import { render, staticRenderFns } from "./okxIndex.vue?vue&type=template&id=c609877c&scoped=true&"
import script from "./okxIndex.vue?vue&type=script&lang=js&"
export * from "./okxIndex.vue?vue&type=script&lang=js&"
import style0 from "./okxIndex.vue?vue&type=style&index=0&id=c609877c&prod&lang=less&scoped=true&"
import style1 from "./okxIndex.vue?vue&type=style&index=1&id=c609877c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c609877c",
  null
  
)

export default component.exports